.page-slider {
	position: relative;
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	justify-content: center;
	margin: auto;
	width: 60%;
	max-width: 1000px;
	height: 100%;
}

.right-arrow {
	position: absolute;
	right: 10px;
	top: 50%;
	transform: translateY(-50%);
}

.left-arrow {
	position: absolute;
	left: 10px;
	top: 50%;
	transform: translateY(-50%);
}

.down-arrow {
	position: absolute;
	bottom: 10px;
	left: 50%;
	transform: translateX(-50%);
}

.up-arrow {
	position: absolute;
	top: 10px;
	left: 50%;
	transform: translateX(-50%);
}

.right-arrow,
.down-arrow,
.up-arrow,
.left-arrow {
	display: flex;
	justify-content: center;
	align-items: center;
	z-index: 1;
	background-color: transparent;
	padding: 0;
	margin: 0;
	border: none;
	cursor: pointer;
	transition: all 0.1s ease-in-out;
}

.right-arrow:focus-visible,
.down-arrow:focus-visible,
.up-arrow:focus-visible,
.left-arrow:focus-visible {
	outline: 2px solid var(--blue-400);
	outline-offset: 2px;
	border-radius: 50%;
}
